import ServicesList from '../components/Services/ServicesList';

export default function ServicesPage() {
  return (
    <div style={{ backgroundColor: '#f0f9f7', minHeight: '100vh', paddingBottom: '60px' }}>
      <ServicesList />
    </div>
  );
}